function injectStyle (ssrContext) {
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-760d7c20\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?{\"includePaths\":[\"/Users/drinkeewu/Desktop/jin10/TV/src/styles/helpers\"],\"data\":\"@import \\\"_function.scss\\\";\",\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./video.vue")
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-760d7c20\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"includePaths\":[\"/Users/drinkeewu/Desktop/jin10/TV/src/styles/helpers\"],\"data\":\"@import \\\"_function.scss\\\";\",\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./video.vue")
}
var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./video.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-760d7c20\",\"hasScoped\":true,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./video.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-760d7c20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/tv/modules/Content/src/video.vue
// module id = JH/5
// module chunks = 2 3 4 6 7 8 9